import gsmMap from '../data/GSM'

const GSM_SINGLE_LENGTH = 160
const GSM_MULTIPLE_LENGTH = 153
const UNICODE_SINGLE_LENGTH = 70
const UNICODE_MULTIPLE_LENGTH = 67

export default class SmsUtils {

  static getEncoding(string) {
    if (!string) return 'GSM'
    const chars = [...string]
    for (let i = 0; i < chars.length; i++) {
      if (!gsmMap[chars[i]]) {
        return 'Unicode'
      }
    }
    return 'GSM'
  }

  static getMessageLength(encoding, string) {
    if (!string) return 0
    const chars = [...string]
    let l = 0
    if (encoding === 'GSM') {
      chars.forEach(c => {
        // the "|| c.length" is a bit of a hack to handle the noUnicodeSupport situation
        l += gsmMap[c] || c.length
      })
    } else {
      chars.forEach(c => {
        l += c.length
      })
    }
    return l
  }

  static getSegmentCharCount(encoding, messageLength) {
    if (encoding === 'GSM') {
      return messageLength > GSM_SINGLE_LENGTH ? GSM_MULTIPLE_LENGTH : GSM_SINGLE_LENGTH
    } else {
      return messageLength > UNICODE_SINGLE_LENGTH ? UNICODE_MULTIPLE_LENGTH : UNICODE_SINGLE_LENGTH
    }
  }

  static getMessageSegments(segmentCharCount, messageLength) {
    return messageLength > segmentCharCount ? Math.floor((messageLength - 1) / segmentCharCount) + 1 : 1
  }

  static getSmsInfo(string, noUnicodeSupport) {
    const encoding = !noUnicodeSupport ? SmsUtils.getEncoding(string) : 'GSM'
    const messageLength = SmsUtils.getMessageLength(encoding, string)
    const segmentCharCount = SmsUtils.getSegmentCharCount(encoding, messageLength)
    const segments = SmsUtils.getMessageSegments(segmentCharCount, messageLength)
    return {
      encoding,
      segments,
      messageLength,
      segmentCharCount
    }
  }

}